/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { TextField } from "@material-ui/core";
import "./styles.css";

import { injectIntl } from "react-intl";
import { connect, useSelector } from "react-redux";
import * as account from "../../_redux/accountRedux";
import { getUserCredit } from "../../_redux/accountCrud";

export function CreditBox(props) {
  const { user } = useSelector((state) => state.auth);
  const [amount, setAmount] = useState("");
  const [credit, setCredit] = useState("");

  useEffect(() => {
    getUserCredit(user).then((res) => {
      setCredit(res.data.credit);
      props.getUserCredit(res.data.credit);
      props.set_loading(false);
    });
  }, [1]);

  // console.log(state);

  const handleBtn = (amount) => {
    // console.log("22222",formatString('1000000'))
    setAmount(amount);
  };

  return (
    <>
      <div
        className={`card card-custom ${props.className}`}
        style={{ height: props.widgetHeight }}
      >
        {/* begin::Body */}
        <div className="card-body">
          <div className="row" style={{ marginRight: 10, marginBottom: 30 }}>
            <div className="row">
              <i className="fa fa-credit-card" style={{ marginLeft: 10 }}></i>
              <h3>افزایش اعتبار</h3>
            </div>
          </div>
          <div className="row">
            <div className={"col col-sm-3 align-self-center"}>
              <h5>
                موجودی حساب : {credit == null ? "0 ریال" : credit.toLocaleString('ar-EG') + "   ریال"}
              </h5>
            </div>
            <div className={"col col-sm-3 flex align-items-end"}>
              {/* begin: Birthday */}
              <TextField
                style={{ marginTop: 25 }}
                id="outlined-name"
                label="مبلغ مورد نظر را وارد کنید"
                margin="normal"
                variant="outlined"
                onChange={(e) => setAmount(e.target.value)}
                value={amount}
              />

              <div className="mt-6 d-flex">
                <button
                  className="btn btn-outline-success mt-6"
                  onClick={(e) => handleBtn(1000000)}
                >
                  1000000
                </button>
                <button
                  className="btn btn-outline-success ml-4 mt-6"
                  onClick={(e) => handleBtn(2000000)}
                >
                  2000000
                </button>
                <button
                  className="btn btn-outline-success ml-4 mt-5"
                  onClick={(e) => handleBtn(3000000)}
                >
                  3000000
                </button>
              </div>
              {/* end: Birthday */}
            </div>
            <div className={"col col-sm-4"}>
              {/* begin: Birthday */}
              <div className="form-group fv-plugins-icon-container ">
                <a
                  href={
                    "https://api.ebus.ir/wallet/pay/mellat/" +
                    amount +
                    "/" +
                    user.id
                  }
                  target="_blank"
                  className="btn btn-primary font-weight-bold py-3 px-6 search-btn"
                >
                  پرداخت
                </a>
              </div>
              <div className="form-group fv-plugins-icon-container ">
                <a
                  href="#"
                  target="_blank"
                  className="btn btn-outline-success font-weight-bold py-3 px-6 search-btn disabled"
                >
                  امکان استرداد اعتبار
                </a>
              </div>
              {/* end: Birthday */}
            </div>
            {/* <div className="col col-sm-4">
							
						</div> */}
          </div>

          {/* <div className="mr-2">
						<div className="text-dark-50 font-size-lg mt-2">
							<div className="row">
								<i className="fa fa-tasks" style={{ marginLeft: 10 }}></i>
								<h3>گزارشات </h3>
							</div>
						</div>
					</div> */}
        </div>
        {/* end::Body */}
      </div>
    </>
  );
}
export default injectIntl(connect(null, account.actions)(CreditBox));
